import React from "react";
import "./PurchaseLogCards.css";

interface StatsCardProps {
  completedPurchases: number;
  ongoingPurchases: number;
  closedClaims: number;
  totalAmountSpent: string;
  totalCreditBalance: string;
}

const StatsCards: React.FC<StatsCardProps> = ({
  completedPurchases,
  ongoingPurchases,
  closedClaims,
  totalAmountSpent,
  totalCreditBalance,
}) => (
  <div className="stats-cards">
    <div className="stats-cards__item stats-cards__item--completed">
      <p className="stats-cards__title">Total Completed Purchases</p>
      <p className="stats-cards__value">{completedPurchases}</p>
    </div>
    <div className="stats-cards__item stats-cards__item--ongoing">
      <p className="stats-cards__title">Ongoing Purchases</p>
      <p className="stats-cards__value">{ongoingPurchases}</p>
    </div>
    <div className="stats-cards__item stats-cards__item--claims">
      <p className="stats-cards__title">Total Closed Claims</p>
      <p className="stats-cards__value">{closedClaims}</p>
    </div>
    <div className="stats-cards__item stats-cards__item--spent">
      <p className="stats-cards__title">Total Revenue</p>
      <p className="stats-cards__value">{totalAmountSpent}</p>
    </div>
    <div className="stats-cards__item stats-cards__item--balance">
      <p className="stats-cards__title">Total Discounts</p>
      <p className="stats-cards__value">{totalCreditBalance}</p>
    </div>
  </div>
);

export default StatsCards;
